<template>
  <!-- <b-timepicker @input="updateValue" rounded :placeholder="label" hour-format="24"></b-timepicker> -->
  <div>
    <div>
      <v-input>{{label}}</v-input>
    </div>
    <div>
      <v-form v-model="valid" ref="form">
        <v-layout class="d-inline-flex">
          <v-select
            class="mr-5"
            :items="hrs"
            v-model="hh"
            :label="$t('hours')"
            @input="updateValue(hh,mm)"
            :rules="rulesRequired"
          ></v-select>
          <v-select
            :items="ms"
            v-model="mm"
            @input="updateValue(hh,mm)"
            :label="$t('minutes')"
            :rules="rulesRequired"
          ></v-select>
          <v-btn icon class="ma-3" color="primary" @click="clear">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <!-- <v-select :items="ms" v-model="ss" ></v-select> -->
        </v-layout>
      </v-form>
    </div>
  </div>
</template>


<script>
//import moment from "moment";
export default {
  props: ["value", "label", "format", "required"],
  data() {
    return {
      valid: true,
      hh: "",
      mm: "",
      ss: "",
      hrs: [],
      ms: []
    };
  },
  beforeUpdate() {},
  watch: {
    async value() {
      await this.createModelValue();
      if (!this.value) this.$refs.form.resetValidation();
      if (!this.valid) this.$refs.form.resetValidation();
    }
  },
  computed: {
    rulesRequired() {
      return this.required ? this.$isRequiredRule : [];
    }
  },
  methods: {
    minutesIsNull(minutes) {
      return minutes && minutes != "" ? minutes : "00";
    },
    isValid() {
      return this.$refs.form.validate();
    },
    clear() {
      this.$emit("input", null);
    },
    updateValue: function(hh, mm) {
      let value = `${hh}:${this.minutesIsNull(mm)}`;
      this.$emit("input", value);
    },
    createHours() {
      for (let index = 0; index < 24; index++) {
        let i = index < 10 ? "0" + index : index.toString();
        this.hrs.push(i);
      }
    },
    createMinutesSeconds() {
      for (let index = 0; index < 60; index++) {
        let i = index < 10 ? "0" + index : index.toString();
        this.ms.push(i);
      }
    },
    requiredSet() {
      if (this.required) {
        if (!this.hh || this.hh == "") this.hh = "00";
        if (!this.mm || this.mm == "") this.mm = "00";
      }
    },
    async createModelValue() {
      if (!this.value) {
        this.hh = null;
        this.mm = null;
        this.requiredSet();
        return;
      }
      let split = this.value.split(":");
      this.hh = this.hrs.filter(h => h == split[0])[0];
      this.mm = this.ms.filter(m => m == split[1])[0];
      this.requiredSet();
    }
  },
  mounted() {
    this.createHours();
    this.createMinutesSeconds();
    this.createModelValue();
    this.$refs.form.resetValidation();
  }
};
</script>
